/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardTeamMembersRouteImport } from './routes/dashboard/team-members'
import { Route as DashboardSkillsBankRouteImport } from './routes/dashboard/skills-bank'
import { Route as DashboardSkillsRouteImport } from './routes/dashboard/skills'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardCustomersRouteImport } from './routes/dashboard/customers'
import { Route as DashboardCalendarRouteImport } from './routes/dashboard/calendar'
import { Route as DashboardTeamMembersIndexRouteImport } from './routes/dashboard/team-members.index'
import { Route as DashboardTeamMembersIdRouteImport } from './routes/dashboard/team-members.$id'
import { Route as DashboardCustomersIndexRouteImport } from './routes/dashboard/customers.index'
import { Route as DashboardCustomersIdRouteImport } from './routes/dashboard/customers.$id'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeamMembersRoute = DashboardTeamMembersRouteImport.update({
  id: '/team-members',
  path: '/team-members',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSkillsBankRoute = DashboardSkillsBankRouteImport.update({
  id: '/skills-bank',
  path: '/skills-bank',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSkillsRoute = DashboardSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCustomersRoute = DashboardCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCalendarRoute = DashboardCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTeamMembersIndexRoute =
  DashboardTeamMembersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardTeamMembersRoute,
  } as any)
const DashboardTeamMembersIdRoute = DashboardTeamMembersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardTeamMembersRoute,
} as any)
const DashboardCustomersIndexRoute =
  DashboardCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCustomersRoute,
  } as any)
const DashboardCustomersIdRoute = DashboardCustomersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardCustomersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/customers': typeof DashboardCustomersRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/skills': typeof DashboardSkillsRoute
  '/dashboard/skills-bank': typeof DashboardSkillsBankRoute
  '/dashboard/team-members': typeof DashboardTeamMembersRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/customers/$id': typeof DashboardCustomersIdRoute
  '/dashboard/customers/': typeof DashboardCustomersIndexRoute
  '/dashboard/team-members/$id': typeof DashboardTeamMembersIdRoute
  '/dashboard/team-members/': typeof DashboardTeamMembersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/customers': typeof DashboardCustomersIndexRoute
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/skills': typeof DashboardSkillsRoute
  '/dashboard/skills-bank': typeof DashboardSkillsBankRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/customers/$id': typeof DashboardCustomersIdRoute
  '/dashboard/team-members/$id': typeof DashboardTeamMembersIdRoute
  '/dashboard/team-members': typeof DashboardTeamMembersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/dashboard/calendar': typeof DashboardCalendarRoute
  '/dashboard/customers': typeof DashboardCustomersRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRoute
  '/dashboard/skills': typeof DashboardSkillsRoute
  '/dashboard/skills-bank': typeof DashboardSkillsBankRoute
  '/dashboard/team-members': typeof DashboardTeamMembersRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/customers/$id': typeof DashboardCustomersIdRoute
  '/dashboard/customers/': typeof DashboardCustomersIndexRoute
  '/dashboard/team-members/$id': typeof DashboardTeamMembersIdRoute
  '/dashboard/team-members/': typeof DashboardTeamMembersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/dashboard/calendar'
    | '/dashboard/customers'
    | '/dashboard/settings'
    | '/dashboard/skills'
    | '/dashboard/skills-bank'
    | '/dashboard/team-members'
    | '/dashboard/'
    | '/dashboard/customers/$id'
    | '/dashboard/customers/'
    | '/dashboard/team-members/$id'
    | '/dashboard/team-members/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/dashboard/calendar'
    | '/dashboard/customers'
    | '/dashboard/settings'
    | '/dashboard/skills'
    | '/dashboard/skills-bank'
    | '/dashboard'
    | '/dashboard/customers/$id'
    | '/dashboard/team-members/$id'
    | '/dashboard/team-members'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/dashboard/calendar'
    | '/dashboard/customers'
    | '/dashboard/settings'
    | '/dashboard/skills'
    | '/dashboard/skills-bank'
    | '/dashboard/team-members'
    | '/dashboard/'
    | '/dashboard/customers/$id'
    | '/dashboard/customers/'
    | '/dashboard/team-members/$id'
    | '/dashboard/team-members/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/team-members': {
      id: '/dashboard/team-members'
      path: '/team-members'
      fullPath: '/dashboard/team-members'
      preLoaderRoute: typeof DashboardTeamMembersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/skills-bank': {
      id: '/dashboard/skills-bank'
      path: '/skills-bank'
      fullPath: '/dashboard/skills-bank'
      preLoaderRoute: typeof DashboardSkillsBankRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/skills': {
      id: '/dashboard/skills'
      path: '/skills'
      fullPath: '/dashboard/skills'
      preLoaderRoute: typeof DashboardSkillsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/customers': {
      id: '/dashboard/customers'
      path: '/customers'
      fullPath: '/dashboard/customers'
      preLoaderRoute: typeof DashboardCustomersRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/calendar': {
      id: '/dashboard/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof DashboardCalendarRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/customers/': {
      id: '/dashboard/customers/'
      path: '/'
      fullPath: '/dashboard/customers/'
      preLoaderRoute: typeof DashboardCustomersIndexRouteImport
      parentRoute: typeof DashboardCustomersRoute
    }
    '/dashboard/customers/$id': {
      id: '/dashboard/customers/$id'
      path: '/$id'
      fullPath: '/dashboard/customers/$id'
      preLoaderRoute: typeof DashboardCustomersIdRouteImport
      parentRoute: typeof DashboardCustomersRoute
    }
    '/dashboard/team-members/': {
      id: '/dashboard/team-members/'
      path: '/'
      fullPath: '/dashboard/team-members/'
      preLoaderRoute: typeof DashboardTeamMembersIndexRouteImport
      parentRoute: typeof DashboardTeamMembersRoute
    }
    '/dashboard/team-members/$id': {
      id: '/dashboard/team-members/$id'
      path: '/$id'
      fullPath: '/dashboard/team-members/$id'
      preLoaderRoute: typeof DashboardTeamMembersIdRouteImport
      parentRoute: typeof DashboardTeamMembersRoute
    }
  }
}

interface DashboardCustomersRouteChildren {
  DashboardCustomersIdRoute: typeof DashboardCustomersIdRoute
  DashboardCustomersIndexRoute: typeof DashboardCustomersIndexRoute
}

const DashboardCustomersRouteChildren: DashboardCustomersRouteChildren = {
  DashboardCustomersIdRoute: DashboardCustomersIdRoute,
  DashboardCustomersIndexRoute: DashboardCustomersIndexRoute,
}

const DashboardCustomersRouteWithChildren =
  DashboardCustomersRoute._addFileChildren(DashboardCustomersRouteChildren)

interface DashboardTeamMembersRouteChildren {
  DashboardTeamMembersIdRoute: typeof DashboardTeamMembersIdRoute
  DashboardTeamMembersIndexRoute: typeof DashboardTeamMembersIndexRoute
}

const DashboardTeamMembersRouteChildren: DashboardTeamMembersRouteChildren = {
  DashboardTeamMembersIdRoute: DashboardTeamMembersIdRoute,
  DashboardTeamMembersIndexRoute: DashboardTeamMembersIndexRoute,
}

const DashboardTeamMembersRouteWithChildren =
  DashboardTeamMembersRoute._addFileChildren(DashboardTeamMembersRouteChildren)

interface DashboardRouteChildren {
  DashboardCalendarRoute: typeof DashboardCalendarRoute
  DashboardCustomersRoute: typeof DashboardCustomersRouteWithChildren
  DashboardSettingsRoute: typeof DashboardSettingsRoute
  DashboardSkillsRoute: typeof DashboardSkillsRoute
  DashboardSkillsBankRoute: typeof DashboardSkillsBankRoute
  DashboardTeamMembersRoute: typeof DashboardTeamMembersRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardCalendarRoute: DashboardCalendarRoute,
  DashboardCustomersRoute: DashboardCustomersRouteWithChildren,
  DashboardSettingsRoute: DashboardSettingsRoute,
  DashboardSkillsRoute: DashboardSkillsRoute,
  DashboardSkillsBankRoute: DashboardSkillsBankRoute,
  DashboardTeamMembersRoute: DashboardTeamMembersRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
